// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { HeaderActionType } from '@Types';
import THEntityLayout from '@Organisms/THEntityLayout/THEntityLayout';
import { useLocalMessage } from '@Helpers/';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import ChildRoutes from './routes';
import { ICONS } from '@Constants/iconsApp';
import { useCurrentUser } from '@Queries/userQueries';
import { findDefaultPath } from '@Helpers/RedirectPath';
import { PermissionsEnum } from 'thehive-sdk';
import { useGetAccessibleRoutes } from '@Helpers/getAccessibleRoutes';

const EntitiesManagementDetails = (): ReactElement | null => {
    const i = useLocalMessage();
    const accessibleRoutes = useGetAccessibleRoutes(ChildRoutes);

    const HeaderActions: HeaderActionType[] = [];

    return (
        <THEntityLayout
            className="layout-org"
            routes={accessibleRoutes}
            title={i('breadcrumb.global.entities-management')}
            actions={HeaderActions}
        />
    );
};

const path = RouteBuilder.compute('administration.entities');

const MenuLink = (): ReactElement => {
    const i = useLocalMessage();
    const { data: currentUser } = useCurrentUser();
    const { permissions = [] } = currentUser || {};
    const defaultPath = findDefaultPath(permissions, {
        [PermissionsEnum.MANAGE_PROFILE]: 'administration.profiles',
        [PermissionsEnum.MANAGE_CUSTOM_FIELD]: 'administration.customFields',
        [PermissionsEnum.MANAGE_OBSERVABLE_TEMPLATE]: 'administration.observables',
        [PermissionsEnum.MANAGE_PLATFORM]: 'administration.case-status',
        //status alert
        [PermissionsEnum.MANAGE_ANALYZER_TEMPLATE]: 'administration.analyzerTemplates',
        [PermissionsEnum.MANAGE_TAXONOMY]: 'administration.taxonomies',
        [PermissionsEnum.MANAGE_PATTERN]: 'administration.attackPatterns',
    });
    return <Link to={RouteBuilder.compute(defaultPath)}>{i('breadcrumb.global.entities-management')}</Link>;
};

export const Route: RouteType = {
    path,
    menu: {
        label: 'organisation.layout.nav-bar.users',
        key: 'entities',
        icon: <ICONS.EntityIcon />,
        render: <MenuLink />,
        selectTab: path,
        group: 'entities-management',
        space: ['admin'],
    },
    permissionNeeded: [
        PermissionsEnum.MANAGE_PROFILE,
        PermissionsEnum.MANAGE_CUSTOM_FIELD,
        PermissionsEnum.MANAGE_OBSERVABLE_TEMPLATE,
        PermissionsEnum.MANAGE_PLATFORM,
        PermissionsEnum.MANAGE_ANALYZER_TEMPLATE,
        PermissionsEnum.MANAGE_TAXONOMY,
        PermissionsEnum.MANAGE_PATTERN,
    ],
    content: <EntitiesManagementDetails />,
    space: ['admin'],
    breadcrumb: {
        label: 'breadcrumb.global.entities-management',
        isLink: false,
    },
};
